// @flow
import React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withUser from "hoc/withUser"
import withSubmit from "hoc/withSubmit"
import withRouter from "hoc/withRouter"
import withConnect from "hoc/withConnect"
import withMutation from "hoc/withMutation"
import { trackReservation } from "analytics/reservations/analyticsTraits"
import urls from "data/router/urls"
import { openModal } from "data/modals/actions"
import type { Reservation } from "data/reservations/types"
import { reservationStatuses } from "data/reservations/constants"
import { cancelReservationMutation } from "data/reservations/graphql/mutations"
import Button from "components/Button"
import ConfirmModal from "modals/Confirm"
import CancellationFeeConfirm from "pages/Reservation/CancellationFeeConfirm"

const CancelReservation = ({ reservation, handleCancel }) => {
  if (reservation.status !== reservationStatuses.confirmed) return null

  return (
    <Button onClick={handleCancel} fullwidth secondary>
      Cancel reservation
    </Button>
  )
}

const mapDispatchToProps = {
  openModal,
}

type Outter = {|
  reservation: Reservation,
|}

const enhancer: HOC<*, Outter> = compose(
  withRouter,
  withConnect(() => ({}), mapDispatchToProps),
  withUser(),
  withMutation(cancelReservationMutation),
  withSubmit({
    redirect: () => urls.reservations,
    successText: "Canceled successfully!",
    errorText: "Failed to cancel reservation, please try again.",
    onSuccess: props => () => {
       // Track charge
       trackReservation(
         "Order Cancelled",
         props.reservation,
         props.user,
         { charged: "applied" },
       )
    },
  }),
  withHandlers({
    handleCancel: props => () => {
      const {
        cancellationFee,
        cancellationFeeStartsAt,
        currency,
        totalPrice,
      } = props.reservation.pricingDetail

      props.openModal(ConfirmModal, {
        title: "Are you sure?",
        component: (
          <CancellationFeeConfirm
            cancellationFee={cancellationFee}
            cancellationFeeStartsAt={cancellationFeeStartsAt}
            currency={currency}
            totalPrice={totalPrice}
          />
        ),
        onConfirm: () => props.submit({ reservationId: props.reservation.id }),
      })
    },
  }),
)

export default enhancer(CancelReservation)



// WEBPACK FOOTER //
// ./src/pages/Reservation/CancelReservation/index.js